import { action, observable } from 'mobx';

/**
 * Classe utilizada para guardar e manipular o estado da aplicação.
 * Deve-se criar uma para cada contexto ou entidade.
 */
class ErrorStore {
    @observable hasError = false;
    @observable error = undefined;
    @observable info = undefined;

    @action reset () {
      this.hasError = false;
      this.error = undefined;
      this.info = undefined;
    }

    @action registrarErro (error, info) {
      this.hasError = true;
      this.error = error;
      this.info = info || error;
    }
}

export default ErrorStore;
